<ng-container *ngIf="isLoading">
  <div class="loading-container">
    <div class="loading-wrapper">
      <app-generic-loading [isLoading]="true"></app-generic-loading>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isLoading">
  <div class="main-carousel-wrapper">
    <app-main-carousel [slides]="bannerItems"></app-main-carousel>
  </div>
</ng-container>
